import { render, staticRenderFns } from "./icon-edit-attribute.vue?vue&type=template&id=0b8f16dc"
import script from "./icon-edit-attribute.vue?vue&type=script&lang=js"
export * from "./icon-edit-attribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports